import React from 'react';
import { Box, Chip, Container, Typography } from '@mui/material';
import minturCo from '../../../../assets/colombiaTravel.png';
import whiteLogo from '../../../../assets/mevuelo-blanco.svg';
import qrPy from '../../../../assets/qrRealConsulting.png';

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';

const contactItems = [
	{
		label: '601 355 7130',
		href: 'tel:576013557130',
		icon: <LocalPhoneIcon />,
	},
	{
		label: 'hola.co@mevuelo.com',
		href: 'mailto:hola.co@mevuelo.com',
		icon: <EmailIcon />,
	},
	{
		label: 'Calle 98 n 9 A 41',
		subtitle: 'Chapinero, Bogotá',
		href: 'https://goo.gl/maps/AbFYcVaSQ67MjwwJ9',
		icon: <LocationOnIcon />,
	},
];

const socialItems = [
	{
		label: 'Facebook',
		value: 'mevuelo.co',
		href: 'https://www.facebook.com/mevuelo.co/',
		icon: <FacebookIcon />,
	},
	{
		label: 'Instagram',
		value: 'mevuelo.co',
		href: 'https://www.instagram.com/mevuelo.co/?hl=es-la',
		icon: <InstagramIcon />,
	},
	{
		label: 'WhatsApp',
		value: '314 292 6276',
		href: 'http://wa.me/573142926276',
		icon: <WhatsAppIcon />,
	},
	{
		label: 'LinkedIn',
		value: 'mevuelo',
		href: 'https://www.linkedin.com/company/mevuelo/',
		icon: <LinkedInIcon />,
	},
];

const linkSx = {
	color: 'inherit',
	textDecoration: 'none',
};

const MevueloCoFooter = (): JSX.Element => {
	return (
		<Box component="footer" sx={{ mt: 4 }}>
			<Container sx={{ px: { xs: 1, sm: 2 } }}>
				<Box
					sx={{
						position: 'relative',
						overflow: 'hidden',
						borderRadius: { xs: '16px 16px 0 0', sm: '16px' },
						background: 'linear-gradient(145deg, #31194B 0%, #3d1b5b 48%, #6d274d 120%)',
						color: 'white',
						px: { xs: 2, sm: 4 },
						pt: { xs: 3, sm: 4 },
						pb: { xs: 3, sm: 4 },
						boxShadow: '0 -10px 30px rgba(49, 25, 75, 0.18)',
					}}
				>
					<Box display="flex" alignItems="center" justifyContent="space-between" gap={2} mb={3}>
						<Box>
							<Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.70)', fontWeight: 800 }}>
								Estamos para ayudarte
							</Typography>
							<Typography variant="h6" fontWeight={800} lineHeight={1.15}>
								Contactá con Mevuelo
							</Typography>
						</Box>
						<a style={linkSx} href="https://www.mevuelo.com.co" target="_blank" rel="noreferrer">
							<img src={whiteLogo} alt="Mevuelo" style={{ width: 104, maxWidth: '28vw' }} />
						</a>
					</Box>

					<Box display="grid" gridTemplateColumns={{ xs: '1fr', sm: 'repeat(3, 1fr)' }} gap={1}>
						{contactItems.map((item) => (
							<a
								key={item.label}
								style={linkSx}
								href={item.href}
								target={item.href.startsWith('http') ? '_blank' : undefined}
								rel="noreferrer"
							>
								<Box
									display="flex"
									alignItems="center"
									gap={1}
									sx={{
										height: '100%',
										p: 1.25,
										borderRadius: '10px',
										backgroundColor: 'rgba(255,255,255,0.08)',
										border: '1px solid rgba(255,255,255,0.10)',
									}}
								>
									<Box sx={{ flex: '0 0 auto', '& svg': { fontSize: 20, color: '#ED6602', display: 'block' } }}>
										{item.icon}
									</Box>
									<Box minWidth={0}>
										<Typography variant="body2" fontWeight={800} lineHeight={1.2} sx={{ overflowWrap: 'anywhere' }}>
											{item.label}
										</Typography>
										{item.subtitle && (
											<Typography
												variant="caption"
												display="block"
												sx={{ color: 'rgba(255,255,255,0.72)', overflowWrap: 'anywhere' }}
											>
												{item.subtitle}
											</Typography>
										)}
									</Box>
								</Box>
							</a>
						))}
					</Box>

					<Box mt={2.5}>
						<Typography variant="body2" fontWeight={800} mb={1}>
							Seguinos
						</Typography>
						<Box display="grid" gridTemplateColumns={{ xs: '1fr 1fr', sm: 'repeat(4, 1fr)' }} gap={1}>
							{socialItems.map((item) => (
								<a key={item.label} style={linkSx} href={item.href} target="_blank" rel="noreferrer">
									<Box
										display="flex"
										alignItems="center"
										gap={1}
										sx={{
											p: 1,
											borderRadius: '999px',
											backgroundColor: 'rgba(255,255,255,0.08)',
											border: '1px solid rgba(255,255,255,0.10)',
											'& svg': { fontSize: 20 },
										}}
									>
										{item.icon}
										<Box minWidth={0}>
											<Typography
												variant="caption"
												display="block"
												lineHeight={1}
												sx={{ color: 'rgba(255,255,255,0.68)' }}
											>
												{item.label}
											</Typography>
											<Typography variant="caption" fontWeight={800} noWrap>
												{item.value}
											</Typography>
										</Box>
									</Box>
								</a>
							))}
						</Box>
					</Box>

					<Box
						mt={2.5}
						sx={{
							p: 1.5,
							borderRadius: '12px',
							backgroundColor: 'rgba(255,255,255,0.10)',
							border: '1px solid rgba(255,255,255,0.12)',
						}}
					>
						<Box display="flex" alignItems="center" gap={1} mb={1}>
							<VerifiedOutlinedIcon sx={{ color: '#ED6602' }} />
							<Typography variant="body2" fontWeight={800}>
								Agencia de viajes registrada
							</Typography>
						</Box>
						<Box
							display="grid"
							gridTemplateColumns={{ xs: '1fr auto', sm: '1fr auto auto' }}
							gap={1.5}
							alignItems="center"
						>
							<Box>
								<Typography variant="body2" fontWeight={800}>
									MEVUELO S.A.S.
								</Typography>
								<Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.72)' }}>
									Resolución REGISTUR Nº 1263/2019
								</Typography>
							</Box>
							<a
								style={linkSx}
								href="https://registur.gov.py/registur/verificacion?qr=e4e4f7c8442ad196282fb79b77bd6abe"
								target="_blank"
								rel="noreferrer"
							>
								<img src={qrPy} alt="QR registro" style={{ width: 76, borderRadius: 8, display: 'block' }} />
							</a>
							<Box display={{ xs: 'none', sm: 'block' }}>
								<img src={minturCo} alt="Colombia Travel" style={{ width: 74, display: 'block' }} />
							</Box>
						</Box>
					</Box>

					<Box display="flex" alignItems="center" justifyContent="space-between" gap={2} mt={2.5} flexWrap="wrap">
						<a style={linkSx} href="https://www.mevuelo.com" target="_blank" rel="noreferrer">
							<Box>
								<Typography variant="caption" display="block" sx={{ color: 'rgba(255,255,255,0.68)' }}>
									Mevuelo está presente en
								</Typography>
								<Chip
									size="small"
									label="Uruguay · Paraguay · Bolivia · Colombia"
									sx={{
										color: 'white',
										borderRadius: '999px',
										fontWeight: 800,
										backgroundColor: 'rgba(255,255,255,0.10)',
										border: '1px solid rgba(255,255,255,0.10)',
									}}
								/>
							</Box>
						</a>
					</Box>
				</Box>
			</Container>
		</Box>
	);
};

export default MevueloCoFooter;
